// extracted by extract-css-chunks-webpack-plugin
module.exports = {"limit-count":"_3M7BmI","limit-count-warning":"_3yuAFV"};